module.exports = __webpack_public_path__ + "img/6_96.0f00746d.png";